import React from 'react';
import CalculatorLayout from './components/calculators-layout/CalculatorLayout';
import ExpandingInfo from './components/calculators-layout/ExpandingInfo';
import InputWithLabel from '../LoanApplication/components/commons/InputWithLabel';
import {ToggleButton, ToggleButtonGroup} from 'react-bootstrap';
import CalculatorForm from './components/calculators-layout/CalculatorForm';
import CalculatorResultCard from './components/calculators-layout/CalculatorResultCard';
import CalculatorCallToActionCard from './components/calculators-layout/CalculatorCallToActionCard';
import CalculatorCostsBreakdown from './components/calculators-layout/CalculatorCostsBreakdown';
import {postSetupCost, getStampDutyResult} from './api';
import CollapseButton from '../../components/CollapseButton';
import {filterProperties} from './utils/filterProperties';
import currencyFormatter from '../../utils/currencyFormatter';
import returnHomeDepositCalculatorOutput from './calculations/homeDepositCalculatorCalculations';
import CalculatorAssumptions from './components/calculators-layout/CalculatorAssumptions';
import HomeDepositAssumptionContent from './AssumptionBoxContent/HomeDepositAssumptionContent';


class HomeDepositCalculator extends React.Component {

  state = {
    propertyPrice: 500000,
    state: 'NSW',
    loanDeposit: 100000,
    loanTarget: 'own_home',
    firstHomeBuyer: true, 
    loanApplicationFee: 0,
    loanEstablishmentFee: 0,
    lendersMortgageInsurance: 0,
    conveyancingFees: 0,
    buildingPestInspection: 0,
    homeInsurance: 0,
    movingExpenses: 0,
    status: "1",
    other: 0,
    errors: {},
    results: {
      governmentCharges: 0,
      loanDeposit: 0,
      loanFees: 0,
      otherCosts: 0,
      totalPropertyBuyingCosts: 0,
    },
  };

  availableStates  = [
    { value: "ACT", label: "ACT" },
    { value: "NSW", label: "NSW" },
    { value: "NT", label: "NT" },
    { value: "QLD", label: "QLD" },
    { value: "SA", label: "SA" },
    { value: "TAS", label: "TAS" },
    { value: "VIC", label: "VIC" },
    { value: "WA", label: "WA" }
  ];

  availableStatus  = [
    { value: "1", label: "Existing" },
    { value: "2", label: "New" },
    { value: "3", label: "Vacant land" },
  ];

  convertCurrencyToDecimal = (currency) => {
    return currency.replace(/[$,]/g, '');
  }

  onCalculationSuccess = async (response) => {
    const result= await getStampDutyResult(this.state);
    const {
      loanDeposit,
      loanApplicationFee,
      loanEstablishmentFee,
      lendersMortgageInsurance,
      conveyancingFees,
      buildingPestInspection,
      homeInsurance,
      movingExpenses, other
    } = this.state;
    
    const homeDepositInputs = {
      stampDuty: parseFloat(this.convertCurrencyToDecimal(result.StampDuty)),
      mortgageRegistration: parseFloat(this.convertCurrencyToDecimal(result.RegistrationFee)),
      transferFee: parseFloat(this.convertCurrencyToDecimal(result.TransferFee)),
      loanDeposit,
      loanApplicationFee,
      loanEstablishmentFee,
      lendersMortgageInsurance,
      conveyancingFees,
      buildingPestInspection,
      homeInsurance,
      movingExpenses,
      other
    }
    
    const results = returnHomeDepositCalculatorOutput(homeDepositInputs);
    this.setState({...this.state, results})
  };

  onCalculationFailure = ({ response }) => {
    let errors = response.data.errors;

    let swalTitle = I18n.t('calculators.generic_error.title');
    let swalText = I18n.t('calculators.generic_error.description');

    if ((response.status) == 422) {
      swalTitle = I18n.t('calculators.generic_error.title');
      swalText = response.data.errors
    }

    swal({
      title: swalTitle,
      text: swalText,
      type: 'warning',
      showCancelButton: false,
      confirmButtonText: 'Close',
      allowOutsideClick: false,
      confirmButtonColor: "#10c98f",
    })
  };

  onCalculationSubmit = () => {
    let data = {
      setup_costs: {...this.state},
    }

    const wantedServerProperties = ['propertyPrice',
      'state',
      'firstHomeBuyer',
      'loanTarget'
    ]
    const originalObject = this.state
    data.setup_costs = filterProperties(originalObject, wantedServerProperties)

    postSetupCost(data,
      this.onCalculationSuccess,
      this.onCalculationFailure
    )
  }

  componentDidMount = () => {
    this.onCalculationSubmit()
  };
  
  expandingLead = (
    <p>Saving for a deposit to purchase a property could often be the biggest hurdle to entering the property market. Use our home deposit calculator to estimate the upfront costs associated with buying a property.</p>
  );
  
  expandingInfoContent = (
    <React.Fragment>
      <p>To start using our property buying costs calculator, enter your property details - estimated property price, state, whether you are a first home buyer and property type (owner-occupied or investment). These details will enable us to provide an estimate of the expected Government stamp duty and fee charges. </p>
      <p>Then you need to factor your loan deposit. Deposit of 20% of property value is typically required to achieve 80% loan-to-value ratio (LVR). If your deposit is less than 20%, Lenders Mortgage Insurace would apply.</p>
      <p>To estimate your total upfront costs, you should also consider other costs such as coneyancing, building & pest inspection reports, moving costs, etc.</p>
    </React.Fragment>
  );
  
  calculatorForm() {
    const {
      propertyPrice,
      state,
      loanDeposit,
      loanTarget,
      firstHomeBuyer,
      loanApplicationFee,
      loanEstablishmentFee,
      lendersMortgageInsurance,
      conveyancingFees,
      buildingPestInspection,
      homeInsurance,
      movingExpenses,
      status,
      other,
      errors
    } = this.state;
    
    return (
      <React.Fragment>
        <div className="numeric-input">
          <InputWithLabel
            label='Property price'
            type='currency'
            defaultValue={propertyPrice}
            errorMessage={errors['propertyPrice']}
            onChange={(value) => this.setState({propertyPrice: value})}
          />
        </div>
        <div className="home-deposit-calculator__state-select select-input">
          <InputWithLabel type='select'
                          label='State/Territory'
                          defaultValue={state}
                          options={ this.availableStates }
                          onChange={(value) => {this.setState({state: value })}} />
        </div>
        <div className="stamp-duty-calculator__state-select select-input">
          <InputWithLabel type='select'
                          label="Property type"
                          defaultValue={status}
                          options={ this.availableStatus }
                          onChange={(value) => {this.setState({status: value })}} />
        </div>
        <div className="numeric-input">
          <InputWithLabel
            label='Loan deposit'
            type='currency'
            defaultValue={loanDeposit}
            errorMessage={errors['loanDeposit']}
            onChange={(value) => this.setState({loanDeposit: value})}
          />
        </div>
        <div className="home-deposit-calculator__toggle-group calculator-toggle-group double">
          <ToggleButtonGroup className='btn-group btn-group-radio-tabs btn-group-toggle btn-group-sm d-flex'
                             type="radio"
                             name="options"
                             defaultValue={'own_home'}
                             onChange={ (value) => { this.setState({ loanTarget: value }) } }>
            <ToggleButton className='btn onboarding-form' value="own_home">I will live there</ToggleButton>
            <ToggleButton className='btn onboarding-form' value="investment">I am investing</ToggleButton>
          </ToggleButtonGroup>
        </div>
        <div className="home-deposit-calculator__toggle-group calculator-toggle-group double">
          <ToggleButtonGroup className='btn-group btn-group-radio-tabs btn-group-toggle btn-group-sm d-flex'
                             type="radio"
                             name="options"
                             defaultValue={true}
                             onChange={ (value) => { this.setState({ firstHomeBuyer: value }) } }>
            <ToggleButton className='btn onboarding-form' value={true}>First home</ToggleButton>
            <ToggleButton className='btn onboarding-form' value={false}>Next home</ToggleButton>
          </ToggleButtonGroup>
        </div>
        <CollapseButton
          id='add-loan-fees'
          openLabel='+ Add loan fees'
          closeLabel='- Remove loan fees'
          onCollapse={() => {this.setState(
            {
              loanApplicationFee: 0,
              loanEstablishmentFee: 0,
              lendersMortgageInsurance: 0,
            }
          )}}
        >
          <p className='calculators-form-section-heading'><strong className='text-uppercase'>Loan Fees</strong></p>
          <div className="numeric-input">
            <InputWithLabel
              label='Loan application fee'
              type='currency'
              defaultValue={loanApplicationFee}
              errorMessage={errors['loanApplicationFee']}
              onChange={(value) => this.setState({loanApplicationFee: value})}
            />
            <InputWithLabel
              label='Loan establishment fee'
              type='currency'
              defaultValue={loanEstablishmentFee}
              errorMessage={errors['loanEstablishmentFee']}
              onChange={(value) => this.setState({loanEstablishmentFee: value})}
            />
            <InputWithLabel
              label="Lender's Mortgage Insurance"
              type='currency'    
              defaultValue={lendersMortgageInsurance}
              errorMessage={errors['lendersMortgageInsurance']}
              onChange={(value) => this.setState({lendersMortgageInsurance: value})}
            />
          </div>
        </CollapseButton>
        <CollapseButton
          id='add-other-costs'
          openLabel='+ Add other costs'
          closeLabel='- Remove other costs'
          onCollapse={() => {this.setState(
            {
              conveyancingFees: 0,
              buildingPestInspection: 0,
              homeInsurance: 0,
              movingExpenses: 0,
              other: 0,
            }
          )}}
        >
          <p className='calculators-form-section-heading'><strong className='text-uppercase'>Other Fees</strong></p>
          <div className="numeric-input">
            <InputWithLabel
              label='Conveyancing fees'
              type='currency'
              defaultValue={conveyancingFees}
              errorMessage={errors['conveyancingFees']}
              onChange={(value) => this.setState({conveyancingFees: value})}
            />
            <InputWithLabel
              label='Building & pest inspection'
              type='currency'
              defaultValue={buildingPestInspection}
              errorMessage={errors['buildingPestInspection']}
              onChange={(value) => this.setState({buildingPestInspection: value})}
            />
            <InputWithLabel
              label="Home insurance"
              type='currency'
              defaultValue={homeInsurance}
              errorMessage={errors['homeInsurance']}
              onChange={(value) => this.setState({homeInsurance: value})}
            />
            <InputWithLabel
              label='Moving expenses'
              type='currency'
              defaultValue={movingExpenses}
              errorMessage={errors['movingExpenses']}
              onChange={(value) => this.setState({movingExpenses: value})}
            />
            <InputWithLabel
              label="Other"
              type='currency'
              defaultValue={other}
              errorMessage={errors['other']}
              onChange={(value) => this.setState({other: value})}
            />            
          </div>
        </CollapseButton>
      </React.Fragment>
    )
  }

  sanitizedSum(numbers) {
    return numbers.reduce( (accumulator, number) => {
      const accValue = number ? parseFloat(number) : 0
      return accumulator + accValue
    }, 0);
  }
  
  resultsColumn() {
    const { results } = this.state

    return results ? <div>
      <CalculatorResultCard
        caption='Total property buying costs'
        figure={currencyFormatter.format(results.totalPropertyBuyingCosts)}
      />
      <CalculatorCallToActionCard>
        <div className='offset-calculator__cta'>
          <p className='offset-calculator__cta-text regular-cta'>Need pre-approval?</p>
        </div>
      </CalculatorCallToActionCard>
      <CalculatorCostsBreakdown
        costs={[
          {
            costText: 'Government charges',
            costAmount: currencyFormatter.format(results.governmentCharges),
          },
          {
            costText: 'Loan deposit',
            costAmount: currencyFormatter.format(results.loanDeposit),
          },
          {
            costText: 'Loan fees',
            costAmount: currencyFormatter.format(results.loanFees),
          },
          {
            costText: 'Other costs',
            costAmount: currencyFormatter.format(results.otherCosts)
          }
        ]}
        totalCost={{
          costText: 'Total property buying costs',
          costAmount: currencyFormatter.format(results.totalPropertyBuyingCosts),
        }}
      />
    </div> : null;
  }
  
  render() {
    return (
      <div className="home-deposit-calculator">
        <CalculatorLayout
          infoRow={<ExpandingInfo lead={this.expandingLead}>{this.expandingInfoContent}</ExpandingInfo>}
          formColumn={
            <CalculatorForm handleSubmit={this.onCalculationSubmit}>{this.calculatorForm()}</CalculatorForm>
          }
          resultsColumn={this.resultsColumn()}
        >
        <CalculatorAssumptions assumptionBoxContents={<HomeDepositAssumptionContent />} />
        </CalculatorLayout>
      </div>
    );
  }
}

export default HomeDepositCalculator;
